import type { TParams } from '@/app/shared/hooks/useQueryParams';

export function formatNavigateURL(contactId: string, urlParams?: TParams | undefined) {
  if (urlParams && urlParams.authId) {
    return `/final/?contactId=${contactId}&authId=${urlParams.authId}&assetId=${urlParams.assetId}&leadId=${urlParams.leadId}&source=${urlParams.source}`;
  }
  return `/final/?contactId=${contactId}`;
}
